import { Injectable }           from '@angular/core';
import { Observable }           from 'rxjs/Observable';
import { Http, Response }       from '@angular/http';
import { JwtHttp, AuthService } from 'ng2-ui-auth';


import 'rxjs/add/operator/map';

@Injectable()
export class RequestBaseService {
  protected ApiUrl: string;

  constructor(
    protected http: JwtHttp,
    protected auth: AuthService
  ) {
  }

  protected validate() {
    if(!this.ApiUrl) {
      throw 'Debe configurar la variable ApiUrl antes el servicio';
    }
  }

  public getApiUrl() {
    return this.ApiUrl;
  }

  public getAll(): Observable<any> {
    this.validate();

    return this.http
      .get(this.ApiUrl)
      .map(res => res.json());
  }

  public getOne(id): Observable<any> {
    this.validate();

    return this.http
      .get([this.ApiUrl, id].join('/'))
      .map(res => res.json());    
  }

  public save(model): Observable<any> {
    this.validate();

    return this.http
      .post(this.ApiUrl, {data: model})
      .map(res => res.json());    
  }

  public update(id, model): Observable<any> {
    this.validate();

    return this.http
      .put([this.ApiUrl, id].join('/'), {data: model})
      .map(res => res.json());    
  }

  public delete(id): Observable<any> {
    this.validate();

    return this.http
      .delete([this.ApiUrl, id].join('/'))
      .map(res => res.json());    
  }

  public guid() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }

    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
      s4() + '-' + s4() + s4() + s4();
  } 
}



// WEBPACK FOOTER //
// ./src/app/services/request-base/request-base.service.ts